import Header from "../../../components/header/Header";
import WebDevHero from "../../../components/Technologies/CloudComputing/CloudComputingHero/CloudComputingHero";
import WebDevTech from "../../../components/Technologies/CloudComputing/CloudComputingTech/CloudComputingTech";
import WebDevExpertise from "../../../components/Technologies/CloudComputing/CloudComputingExperties/CloudComputingExpertise";
import WebDevOutcomes from "../../../components/Technologies/CloudComputing/CloudComputingOutcomes/CloudComputingOutcomes";
import WebDevImpactCTA from "../../../components/Technologies/CloudComputing/CloudComputingImpactCTA/CloudComputingImpactCTA";
import Footer from "../../../components/Footer/Footer";
const CloudComputing = () => {
  return (
    <>
      <Header />
      <WebDevHero />
      <WebDevTech />
      <WebDevExpertise />
      <WebDevOutcomes />
      <WebDevImpactCTA />
      <Footer />
    </>
  );
};

export default CloudComputing;
